module.exports = __webpack_public_path__ + "ecfa0416da68d1692854d577d73134af.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/glyphs/p.png
// module id = 219
// module chunks = 0